import { createAction } from '@reduxjs/toolkit'

const resetNotification = createAction('RESET_NOTIFICATION')

export default resetNotification
